export default {
  status: [
    { msg: '正常', code: 200, subMsg: '' },
    { msg: '已结束', code: 500, subMsg: '' },
    { msg: '已取消', code: 300, subMsg: '' },
    {},
    { msg: '已改签', code: 200, subMsg: '' },
    { msg: '即将开始', subMsg: '', code: 100 },
    { msg: '取消成功', subMsg: '积分和退款将立即退回你的账户', code: 200 },
    {
      msg: '改签成功',
      subMsg: '该预约不可再次改签, 如需再次变更请取消并重新预约',
      code: 200,
    },
    { msg: '已开场', code: 200, subMsg: '' },
  ],

  resStatus: {
    0: { msg: '已预约', code: 200, subMsg: '' },
    2: { msg: '已取消', code: 500, subMsg: '' },
    3: {},
    4: { msg: '已改签', code: 200, subMsg: '' },
    5: { msg: '已参观', subMsg: '', code: 100 },
  },
  resScheduleStatus: {
    0: { msg: '太早了', code: 200, subMsg: '' },
    1: { msg: '即将开始', code: 500, subMsg: '' },
    2: { msg: '已开场', code: 200, subMsg: '' },
    3: { msg: '已过期', subMsg: '', code: 100 },
  },

  resStatusVO: {
    0: { msg: '已预约', code: 200, subMsg: '' },
    1: { msg: '已取消', code: 500, subMsg: '' },
    2: { msg: '已改签', code: 200, subMsg: '' },
    3: { msg: '已参观', code: 500, subMsg: '' },
    4: { msg: '即将开始', code: 100, subMsg: '' },
    5: { msg: '已开场', code: 100, subMsg: '' },
    6: { msg: '已过期', code: 500, subMsg: '' },
  },

  btn: {
    reschedule: '改签',
    cancel: '取消预约',
    more: '再订一张',
  },
  res1: {
    title: '预约体验时间',
  },
  res2: {
    title: '选择购票方式',
  },
  res3: {
    title: '参观人员',
  },
  res4: {
    title: '信息确认',
  },
  success: '预约成功',
  word: {
    point: '积分',
  },
  tickets: [
    {
      title: '探店模式',
      point: 88,
      price: 0,
      body: [
        '儿童半价',
        '不包含以下展项体验：飞跃蚂蚁森林/DAMO 5G赛车漂移/互动区',
      ],
    },
    {
      title: '钻石会员套票',
      grade: 'diamond',
      point: 88,
      price: 20,
      body: ['儿童半价', '包含所有展项体验'],
    },
    {
      title: '钻石会员套票积分兑换',
      grade: 'diamond',
      point: 2800,
      price: 0,
      body: ['儿童半价', '包含所有展项体验'],
    },
  ],
}
